document.addEventListener( 'DOMContentLoaded', function () {
	const app = document.querySelector( '[data-auth-app]' );
	const authConfig = window.SweettySpaceAuth;

	if ( ! app || typeof authConfig === 'undefined' ) {
		return;
	}

	const config = authConfig;
	const tabs = Array.from( app.querySelectorAll( '[data-auth-tab]' ) );
	const panels = Array.from( app.querySelectorAll( '[data-auth-panel]' ) );
	const globalError = app.querySelector( '[data-auth-global-error]' );
	const otpModal = document.querySelector( '[data-auth-otp-modal]' );
	const otpEmailInput = otpModal
		? otpModal.querySelector( '[data-auth-otp-email]' )
		: null;
	const otpFlowInput = otpModal
		? otpModal.querySelector( '[data-auth-otp-flow]' )
		: null;
	const otpMessage = otpModal
		? otpModal.querySelector( '[data-auth-otp-message]' )
		: null;
	const otpError = otpModal
		? otpModal.querySelector( '[data-auth-otp-error]' )
		: null;
	const resendTimerNode = otpModal
		? otpModal.querySelector( '[data-auth-resend-timer]' )
		: null;
	const resetEmailInput = app.querySelector( '[data-auth-reset-email]' );
	const resetCodeInput = app.querySelector( '[data-auth-reset-code]' );
	const registerPhoneInput = app.querySelector( '#auth-register-phone' );
	const resendCooldown = Number( config.resendCooldown ) || 60;
	let resendCooldownUntil = 0;
	let resendTimerId = null;
	let phoneMask = null;

	function setGlobalError( message ) {
		if ( ! globalError ) {
			return;
		}

		if ( ! message ) {
			globalError.hidden = true;
			globalError.textContent = '';
			return;
		}

		globalError.hidden = false;
		globalError.textContent = message;
	}

	function setOtpError( message ) {
		if ( ! otpError ) {
			return;
		}

		if ( ! message ) {
			otpError.hidden = true;
			otpError.textContent = '';
			return;
		}

		otpError.hidden = false;
		otpError.textContent = message;
	}

	function clearFormErrors( form ) {
		if ( ! form ) {
			return;
		}

		form.querySelectorAll( '.auth-field__error' ).forEach(
			function ( node ) {
				node.textContent = '';
			}
		);

		form.querySelectorAll( '.is-invalid' ).forEach( function ( node ) {
			node.classList.remove( 'is-invalid' );
		} );
	}

	function setFormErrors( form, errors ) {
		clearFormErrors( form );

		if ( ! errors ) {
			return;
		}

		Object.keys( errors ).forEach( function ( key ) {
			const errorNode = form.querySelector(
				'[data-error-for="' + key + '"]'
			);
			const field = form.querySelector( '[name="' + key + '"]' );

			if ( errorNode ) {
				errorNode.textContent = errors[ key ];
			}

			if ( field ) {
				field.classList.add( 'is-invalid' );
			}
		} );
	}

	function setActivePanel( panelName ) {
		panels.forEach( function ( panel ) {
			const isActive =
				panel.getAttribute( 'data-auth-panel' ) === panelName;
			panel.hidden = ! isActive;
			panel.classList.toggle( 'is-active', isActive );
		} );

		tabs.forEach( function ( tab ) {
			const isActive = tab.getAttribute( 'data-auth-tab' ) === panelName;
			tab.classList.toggle( 'is-active', isActive );
			tab.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
		} );

		setGlobalError( '' );
	}

	function normalizePanelName( value ) {
		const normalized = ( value || '' )
			.toString()
			.trim()
			.toLowerCase()
			.replace( /^#/, '' );

		if ( normalized === 'register' ) {
			return 'register';
		}

		if (
			normalized === 'forgot-password' ||
			normalized === 'forgot_password' ||
			normalized === 'reset' ||
			normalized === 'reset-password' ||
			normalized === 'reset_password'
		) {
			return 'reset-request';
		}

		if ( normalized === 'login' || normalized === 'signin' ) {
			return 'login';
		}

		return '';
	}

	function hasValidResetResumeParams( params ) {
		const email = params.get( 'email' ) || '';
		const flow = params.get( 'flow' ) || '';
		const code = ( params.get( 'code' ) || '' ).replace( /\D+/g, '' );

		return (
			flow === 'reset_password' &&
			validateEmail( email ) &&
			/^\d{6}$/.test( code )
		);
	}

	function syncUrlState( panelName ) {
		if ( ! window.history || ! window.history.replaceState ) {
			return;
		}

		const url = new URL( window.location.href );

		if ( panelName === 'register' ) {
			url.searchParams.set( 'act', 'register' );
			url.searchParams.delete( 'email' );
			url.searchParams.delete( 'flow' );
			url.searchParams.delete( 'code' );
			url.hash = 'register';
		} else if ( panelName === 'reset-request' ) {
			url.searchParams.set( 'act', 'forgot-password' );
			url.searchParams.delete( 'email' );
			url.searchParams.delete( 'flow' );
			url.searchParams.delete( 'code' );
			url.hash = 'forgot-password';
		} else {
			url.searchParams.delete( 'act' );
			url.searchParams.delete( 'email' );
			url.searchParams.delete( 'flow' );
			url.searchParams.delete( 'code' );
			url.hash = 'login';
		}

		window.history.replaceState( {}, '', url.toString() );
	}

	function syncResetCompleteUrlState( email, code ) {
		if ( ! window.history || ! window.history.replaceState ) {
			return;
		}

		const url = new URL( window.location.href );
		url.searchParams.set( 'act', 'forgot-password' );
		url.searchParams.set( 'email', email );
		url.searchParams.set( 'flow', 'reset_password' );
		url.searchParams.set( 'code', code );
		url.hash = 'forgot-password';

		window.history.replaceState( {}, '', url.toString() );
	}

	function resolveInitialState() {
		const params = new URLSearchParams( window.location.search );

		if ( hasValidResetResumeParams( params ) ) {
			return {
				panel: 'reset-complete',
				email: params.get( 'email' ) || '',
				code: ( params.get( 'code' ) || '' ).replace( /\D+/g, '' ),
				flow: params.get( 'flow' ) || '',
			};
		}

		const byQuery = normalizePanelName( params.get( 'act' ) );

		if ( byQuery ) {
			return {
				panel: byQuery,
				email: '',
				code: '',
				flow: '',
			};
		}

		const byHash = normalizePanelName( window.location.hash );

		if ( byHash ) {
			return {
				panel: byHash,
				email: '',
				code: '',
				flow: '',
			};
		}

		return {
			panel: 'login',
			email: '',
			code: '',
			flow: '',
		};
	}

	function collectFormData( form ) {
		const formData = new FormData();

		Array.from( new window.FormData( form ).entries() ).forEach(
			function ( entry ) {
				formData.append( entry[ 0 ], entry[ 1 ] );
			}
		);

		formData.append( 'nonce', config.nonce );

		return formData;
	}

	function setSubmitting( form, state ) {
		if ( ! form ) {
			return;
		}

		form.classList.toggle( 'is-submitting', state );

		form.querySelectorAll( 'button, input' ).forEach( function ( node ) {
			if ( node.type === 'hidden' ) {
				return;
			}

			if ( node.hasAttribute( 'data-auth-close-modal' ) ) {
				return;
			}

			node.disabled = state;
		} );
	}

	function request( action, formData ) {
		formData.append( 'action', action );

		return window
			.fetch( config.ajaxUrl, {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
			} )
			.then( function ( response ) {
				return response.json().then( function ( payload ) {
					if ( ! response.ok || ! payload.success ) {
						const errorPayload =
							payload && payload.data
								? payload.data
								: {
										message: 'Request failed',
										errors: {},
								  };

						throw errorPayload;
					}

					return payload.data;
				} );
			} );
	}

	function openOtpModal( flow, email, message ) {
		if ( ! otpModal ) {
			return;
		}

		otpEmailInput.value = email;
		otpFlowInput.value = flow;
		otpModal.hidden = false;
		otpModal.classList.add( 'is-open' );
		otpModal.querySelector( 'input[name="code"]' ).value = '';
		otpMessage.textContent = message || '';
		setOtpError( '' );
		clearFormErrors( otpModal.querySelector( 'form' ) );
		resendCooldownUntil = Math.floor( Date.now() / 1000 ) + resendCooldown;
		startResendTimer();
	}

	function closeOtpModal() {
		if ( ! otpModal ) {
			return;
		}

		otpModal.classList.remove( 'is-open' );
		otpModal.hidden = true;
		setOtpError( '' );
		clearFormErrors( otpModal.querySelector( 'form' ) );
	}

	function startResendTimer() {
		if ( ! resendTimerNode ) {
			return;
		}

		window.clearInterval( resendTimerId );

		function tick() {
			const secondsLeft =
				resendCooldownUntil - Math.floor( Date.now() / 1000 );

			if ( secondsLeft <= 0 ) {
				resendTimerNode.textContent = '';
				window.clearInterval( resendTimerId );
				return;
			}

			resendTimerNode.textContent =
				'Можна повторити через ' + secondsLeft + 'с';
		}

		tick();
		resendTimerId = window.setInterval( tick, 1000 );
	}

	function validateEmail( value ) {
		return /\S+@\S+\.\S+/.test( value );
	}

	function normalizePhone( value ) {
		const digits = ( value || '' ).replace( /\D+/g, '' );

		if ( digits.length === 10 && digits.charAt( 0 ) === '0' ) {
			return '+38' + digits;
		}

		if ( digits.length === 12 && digits.indexOf( '380' ) === 0 ) {
			return '+' + digits;
		}

		return value || '';
	}

	function formatUaPhoneForDisplay( value ) {
		const normalized = normalizePhone( value ).replace( /\D+/g, '' );

		if ( normalized.length !== 12 || normalized.indexOf( '380' ) !== 0 ) {
			return value || '';
		}

		const subscriber = normalized.slice( 2 );

		return (
			'+38 (' +
			subscriber.slice( 0, 3 ) +
			') ' +
			subscriber.slice( 3, 7 ) +
			' ' +
			subscriber.slice( 7 )
		);
	}

	function isValidPhone( value ) {
		const normalized = normalizePhone( value );

		if (
			! normalized ||
			typeof window.libphonenumber === 'undefined' ||
			typeof window.libphonenumber.parsePhoneNumberFromString !==
				'function'
		) {
			return false;
		}

		const phone = window.libphonenumber.parsePhoneNumberFromString(
			normalized,
			config.phoneRegion || 'UA'
		);

		return Boolean(
			phone &&
				phone.isValid() &&
				( ! phone.country ||
					phone.country === ( config.phoneRegion || 'UA' ) )
		);
	}

	function initPhoneField() {
		if ( ! registerPhoneInput || typeof window.Inputmask === 'undefined' ) {
			return;
		}

		phoneMask = new window.Inputmask( {
			mask: config.phoneMask || '+38 (099) 9999 999',
			clearIncomplete: false,
			showMaskOnHover: false,
			showMaskOnFocus: true,
			placeholder: '_',
		} );

		phoneMask.mask( registerPhoneInput );

		registerPhoneInput.addEventListener( 'blur', function () {
			if ( isValidPhone( registerPhoneInput.value ) ) {
				registerPhoneInput.value = formatUaPhoneForDisplay(
					registerPhoneInput.value
				);
			}
		} );
	}

	function clientValidate( formName, form ) {
		const errors = {};
		const data = Object.fromEntries(
			new window.FormData( form ).entries()
		);

		if ( formName === 'login' ) {
			if ( ! validateEmail( data.email || '' ) ) {
				errors.email = config.messages.invalidEmail;
			}

			if ( ! ( data.password || '' ).trim() ) {
				errors.password = config.messages.required;
			}
		}

		if ( formName === 'register' ) {
			// [ 'first_name', 'last_name', 'phone' ].forEach( function ( key ) {
			// 	if ( ! ( data[ key ] || '' ).trim() ) {
			// 		errors[ key ] = config.messages.required;
			// 	}
			// } );

			if (
				( data.phone || '' ).trim() &&
				! errors.phone &&
				! isValidPhone( data.phone || '' )
			) {
				errors.phone = config.messages.invalidPhone;
			}

			if ( ! validateEmail( data.email || '' ) ) {
				errors.email = config.messages.invalidEmail;
			}

			if ( ( data.password || '' ).length < 8 ) {
				errors.password = config.messages.passwordMin;
			}

			if ( ( data.password || '' ) !== ( data.password_confirm || '' ) ) {
				errors.password_confirm = config.messages.passwordMatch;
			}
		}

		if ( formName === 'reset-request' ) {
			if ( ! validateEmail( data.email || '' ) ) {
				errors.email = config.messages.invalidEmail;
			}
		}

		if ( formName === 'reset-complete' ) {
			if ( ( data.password || '' ).length < 8 ) {
				errors.password = config.messages.passwordMin;
			}

			if ( ( data.password || '' ) !== ( data.password_confirm || '' ) ) {
				errors.password_confirm = config.messages.passwordMatch;
			}
		}

		if ( formName === 'otp' ) {
			if ( ! /^\d{6}$/.test( data.code || '' ) ) {
				errors.code = config.messages.otpInvalid;
			}
		}

		return errors;
	}

	function handleAjaxError( form, error, isOtpForm ) {
		const message =
			error && error.message ? error.message : 'Щось пішло не так.';
		const errors = error && error.errors ? error.errors : {};

		if ( form ) {
			setFormErrors( form, errors );
		}

		if ( isOtpForm ) {
			setOtpError( message );
			return;
		}

		setGlobalError( message );
	}

	app.querySelectorAll( '[data-auth-switch]' ).forEach( function ( button ) {
		button.addEventListener( 'click', function () {
			const panelName = button.getAttribute( 'data-auth-switch' );
			setActivePanel( panelName );
			syncUrlState( panelName );
		} );
	} );

	tabs.forEach( function ( button ) {
		button.addEventListener( 'click', function () {
			const panelName = button.getAttribute( 'data-auth-tab' );
			setActivePanel( panelName );
			syncUrlState( panelName );
		} );
	} );

	app.querySelectorAll( '[data-auth-open-reset]' ).forEach(
		function ( button ) {
			button.addEventListener( 'click', function () {
				setActivePanel( 'reset-request' );
				syncUrlState( 'reset-request' );
			} );
		}
	);

	document
		.querySelectorAll( '[data-auth-close-modal]' )
		.forEach( function ( button ) {
			button.addEventListener( 'click', closeOtpModal );
		} );

	document
		.querySelectorAll( '[data-password-toggle]' )
		.forEach( function ( button ) {
			button.addEventListener( 'click', function () {
				const wrapper = button.closest( '.auth-input--password' );
				const input = wrapper ? wrapper.querySelector( 'input' ) : null;

				if ( ! input ) {
					return;
				}

				const label = button.querySelector(
					'[data-password-toggle-label]'
				);
				const show = input.type === 'password';
				input.type = show ? 'text' : 'password';

				if ( label ) {
					label.textContent = show ? 'Сховати' : 'Показати';
				}
			} );
		} );

	document.querySelectorAll( '[data-auth-form]' ).forEach( function ( form ) {
		form.addEventListener( 'submit', function ( event ) {
			event.preventDefault();

			const formName = form.getAttribute( 'data-auth-form' );
			const localErrors = clientValidate( formName, form );
			clearFormErrors( form );
			setGlobalError( '' );
			setOtpError( '' );

			if ( Object.keys( localErrors ).length ) {
				setFormErrors( form, localErrors );
				return;
			}

			const requestData = collectFormData( form );
			setSubmitting( form, true );
			const actionMap = {
				login: 'ss_auth_login',
				register: 'ss_auth_register_start',
				'reset-request': 'ss_auth_reset_start',
				'reset-complete': 'ss_auth_reset_complete',
				otp:
					otpFlowInput && otpFlowInput.value === 'reset_password'
						? 'ss_auth_reset_verify'
						: 'ss_auth_register_verify',
			};

			request( actionMap[ formName ], requestData )
				.then( function ( data ) {
					if ( formName === 'login' ) {
						window.location.href =
							data.redirect || config.redirectUrl;
						return;
					}

					if (
						formName === 'register' ||
						formName === 'reset-request'
					) {
						openOtpModal( data.flow, data.email, data.message );
						return;
					}

					if ( formName === 'otp' ) {
						if ( otpFlowInput.value === 'reset_password' ) {
							closeOtpModal();
							resetEmailInput.value =
								data.email || otpEmailInput.value;
							resetCodeInput.value =
								data.code ||
								form.querySelector( '[name="code"]' ).value;
							setActivePanel( 'reset-complete' );
							syncResetCompleteUrlState(
								resetEmailInput.value,
								resetCodeInput.value
							);
							return;
						}

						window.location.href =
							data.redirect || config.redirectUrl;
						return;
					}

					if ( formName === 'reset-complete' ) {
						window.location.href =
							data.redirect || config.redirectUrl;
					}
				} )
				.catch( function ( error ) {
					handleAjaxError( form, error, formName === 'otp' );
				} )
				.finally( function () {
					setSubmitting( form, false );
				} );
		} );
	} );

	const resendButton = otpModal
		? otpModal.querySelector( '[data-auth-resend-code]' )
		: null;

	if ( resendButton ) {
		resendButton.addEventListener( 'click', function () {
			if ( Math.floor( Date.now() / 1000 ) < resendCooldownUntil ) {
				return;
			}

			const formData = new FormData();
			formData.append( 'email', otpEmailInput.value );
			formData.append( 'flow', otpFlowInput.value );
			formData.append( 'nonce', config.nonce );

			resendButton.disabled = true;
			setOtpError( '' );

			request( 'ss_auth_resend_code', formData )
				.then( function () {
					resendCooldownUntil =
						Math.floor( Date.now() / 1000 ) + resendCooldown;
					startResendTimer();
				} )
				.catch( function ( error ) {
					setOtpError(
						error && error.message
							? error.message
							: 'Не вдалося надіслати код.'
					);
				} )
				.finally( function () {
					resendButton.disabled = false;
				} );
		} );
	}

	initPhoneField();
	const initialState = resolveInitialState();

	if ( initialState.panel === 'reset-complete' ) {
		resetEmailInput.value = initialState.email;
		resetCodeInput.value = initialState.code;
	}

	setActivePanel( initialState.panel );

	window.addEventListener( 'hashchange', function () {
		const params = new URLSearchParams( window.location.search );

		if ( hasValidResetResumeParams( params ) ) {
			resetEmailInput.value = params.get( 'email' ) || '';
			resetCodeInput.value = ( params.get( 'code' ) || '' ).replace(
				/\D+/g,
				''
			);
			setActivePanel( 'reset-complete' );
			return;
		}

		const panelName = normalizePanelName( window.location.hash );

		if ( panelName ) {
			setActivePanel( panelName );
		}
	} );
} );
